import { Component, OnInit, DoCheck, ViewChild } from '@angular/core';
import { SaleService } from '../../../service/sale.service';

//DATATABLE
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

//RXJS
import { Observable, BehaviorSubject } from 'rxjs';
import { map, take } from 'rxjs/operators';

//MODELO
import { Sales, Empresa } from '../../../model/sale.model';

@Component({
  selector: 'app-sale-list',
  templateUrl: './sale-list.component.html',
  styleUrls: ['./sale-list.component.css'],
})
export class SaleListComponent implements OnInit, DoCheck {
  constructor(private service: SaleService) {}
  public masVenta: number;
  public bestMonthSeller: string;
  public bestMonthCount: number;
  public data: Empresa[] = [];
  public months: { mes: string; number: number }[] = [
    { mes: 'Enero', number: 1 },
    { mes: 'Febrero', number: 2 },
    { mes: 'Marzo', number: 3 },
    { mes: 'Abril', number: 4 },
    { mes: 'Mayo', number: 5 },
    { mes: 'Junio', number: 6 },
    { mes: 'Julio', number: 7 },
    { mes: 'Agosto', number: 8 },
    { mes: 'Septiembre', number: 9 },
    { mes: 'Octubre', number: 10 },
    { mes: 'Noviembre', number: 11 },
    { mes: 'Diciembre', number: 12 },
  ];
  finalPrice: number = 0;
  subject: BehaviorSubject<Sales[]> = new BehaviorSubject<any>([]);
  array$: Observable<any> = this.subject.asObservable();
  listData: MatTableDataSource<Empresa>;
  arrNameAgency = [];
  public windowSize: any;
  displayedColumns: string[] = ['nombre', 'monto', 'comision', 'actions'];
  displayedMobileColumns: string[] = ['information', 'actions'];
  searchKey: string;
  //Directives
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit(): void {
    this.service.getSales().subscribe((list) => {
      list.map((item) => {
        //console.log(item.payload.val());
        this.addElementToObservableArray(item.payload.val());
      });
    });

    // rxjs handle payload observable
    this.array$
      .pipe(
        map((res) => {
          return res;
        })
      )
      .subscribe((final: Sales) => {
        this.data = this.empresasMasVentas(final);

        //console.log(data);
        this.listData = new MatTableDataSource(this.data);
        this.listData.sort = this.sort;
        this.listData.paginator = this.paginator;
      });
  }

  addElementToObservableArray(item) {
    this.array$.pipe(take(1)).subscribe((val) => {
      // console.log(val);
      const newArr = [...val, item];
      this.subject.next(newArr);
    });
  }

  ngDoCheck() {
    this.onResize();
  }

  onSearchClear() {
    this.searchKey = '';
    this.applyFilter();
  }

  applyFilter() {
    this.listData.filter = this.searchKey.trim().toLowerCase();
  }

  onView(row) {
    console.log(row);
  }

  onResize() {
    this.windowSize = { x: window.innerWidth, y: window.innerHeight };
  }

  empresasMasVentas(sale: any) {
    const arrEmpresaMasGanancia = [];
    const arrMesMasVendido = [];

    let earn_Ruhiscos = 0;
    const client_Ruhiscos = sale.filter((empresa, i) => {
      if (empresa.nameAgency === 'Ruhiscos Aventuras Spa') {
        earn_Ruhiscos = empresa.finalPrice + earn_Ruhiscos;
        return empresa;
      }
    });
    let earn_fuegos = 0;
    const client_Fuegos = sale.filter((empresa, i) => {
      if (empresa.nameAgency === 'Fuego Nativo') {
        earn_fuegos = empresa.finalPrice + earn_fuegos;
        return empresa;
      }
    });
    let earn_test = 0;
    const client_Test = sale.filter((empresa, i) => {
      if (empresa.nameAgency === 'test') {
        earn_test = empresa.finalPrice + earn_test;
        return empresa;
      }
    });
    let earn_Fortuna = 0;
    const client_Fortuna = sale.filter((empresa, i) => {
      if (empresa.nameAgency === 'Por fortuna') {
        earn_Fortuna = empresa.finalPrice + earn_Fortuna;
        return empresa;
      }
    });
    let earn_Agencia_1 = 0;
    const client_Agencia_1 = sale.filter((empresa, i) => {
      if (empresa.nameAgency === 'Agencia 1') {
        earn_Agencia_1 = empresa.finalPrice + earn_Agencia_1;
        return empresa;
      }
    });
    const sales_Count_Agencia_1 = client_Agencia_1.length;
    const sales_Count_Fortuna = client_Fortuna.length;
    const sales_Count_Test = client_Test.length;
    const sales_Count_Fuegos = client_Fuegos.length;
    const sales_Count_Rhuiscos = client_Ruhiscos.length;

    arrEmpresaMasGanancia.push({
      nombre: 'Ruhiscos Aventuras Spa',
      monto: earn_Ruhiscos,
      comision: Number(earn_Ruhiscos * 0.025),
      ventas: sales_Count_Agencia_1,
      link: 'Ruhiscos_Aventuras_Spa',
    });
    arrEmpresaMasGanancia.push({
      nombre: 'Fuego Nativo',
      monto: earn_fuegos,
      comision: Number(earn_fuegos * 0.025),
      ventas: sales_Count_Fortuna,
      link: 'Fuego_Nativo',
    });
    arrEmpresaMasGanancia.push({
      nombre: 'test',
      monto: earn_test,
      comision: Number(earn_test * 0.025),
      ventas: sales_Count_Test,
      link: 'test',
    });
    arrEmpresaMasGanancia.push({
      nombre: 'Por fortuna',
      monto: earn_Fortuna,
      comision: Number(earn_Fortuna * 0.025),
      ventas: sales_Count_Fuegos,
      link: 'Por_Fortuna',
    });
    arrEmpresaMasGanancia.push({
      nombre: 'Agencia 1',
      monto: earn_Agencia_1,
      comision: Number(earn_Agencia_1 * 0.025),
      ventas: sales_Count_Rhuiscos,
      link: 'Agencia_1',
    });

    sale.map((client) => {
      const fecha = client.datePayment.split(' ')[0].split('-').reverse()[1];
      arrMesMasVendido.push(parseInt(fecha));
    });

    const SellerMonth = this.mesMasVendido(arrMesMasVendido);

    setTimeout(() => {
      SellerMonth.map((seller, i) => {
        if (i === 0) {
          const month = this.months.filter((mes) => {
            return mes.number === seller;
          });

          // Best Month
          this.bestMonthSeller = month[0].mes;
          this.bestMonthCount = month[0].number;
        }
      });
    }, 200);

    //sort
    arrEmpresaMasGanancia.sort((a, b) => b.monto - a.monto);

    // Bigger sell Value achive
    this.masVenta = arrEmpresaMasGanancia[0].monto;

    return arrEmpresaMasGanancia;
  }

  mesMasVendido(ar: any) {
    return ar.reduce(
      (acum, el, i, ar) => {
        const count = ar.filter((e) => e == el).length;
        return count > acum[1] ? [el, count] : acum;
      },
      ['', 0]
    );
  }
}
